import { assign, createMachine } from 'xstate';

export interface Step {
  step: string;
  title: CreateVisitTitle;
  isSubStep: boolean;
}

export enum CreateVisitStates {
  VISITOR_DETAILS = 'visitor-details',
  DATES_INFO = 'dates-info',
  HOST_INFO = 'host-info',
  DESTINATION_INFO = 'destination-info',
  ADDITIONAL_INFORMATION = 'additional-information',
  CONFIRMATION = 'confirmation',
}

export enum CreateVisitTitle {
  HOST_INFO = 'createVisit:steps.host',
  DESTINATION_INFO = 'createVisit:steps.destination',
  VISITOR_DETAILS = 'createVisit:steps.visitors',
  DATES_INFO = 'createVisit:steps.dates',
  ADDITIONAL_INFORMATION = 'createVisit:steps.additionalInformation',
  CONFIRMATION = 'createVisit:steps.confirmation',
}

export interface CreateVisitContext {
  step: string;
  content: CreateVisitTitle;
}

export type CreateVisitEvent =
  | {
      type: 'NEXT';
    }
  | {
      type: 'BACK';
    };

export const createVisitMachine = createMachine({
  types: {} as {
    context: CreateVisitContext;
    states: {
      [CreateVisitStates.VISITOR_DETAILS]: unknown;
      [CreateVisitStates.DATES_INFO]: unknown;
      [CreateVisitStates.HOST_INFO]: unknown;
      [CreateVisitStates.DESTINATION_INFO]: unknown;
      [CreateVisitStates.ADDITIONAL_INFORMATION]: unknown;
      [CreateVisitStates.CONFIRMATION]: unknown;
    };
    events: CreateVisitEvent;
  },
  id: 'create-visit',
  context: ({ input }: { input: CreateVisitContext }) => ({
    step: input?.step || '1',
    content: CreateVisitTitle.HOST_INFO,
  }),
  initial: CreateVisitStates.HOST_INFO,
  states: {
    [CreateVisitStates.HOST_INFO]: {
      on: {
        NEXT: {
          target: CreateVisitStates.DESTINATION_INFO,
          actions: assign({
            step: '2',
            content: CreateVisitTitle.DESTINATION_INFO,
          }),
        },
      },
    },
    [CreateVisitStates.DESTINATION_INFO]: {
      on: {
        BACK: {
          target: CreateVisitStates.HOST_INFO,
          actions: assign({
            step: '1',
            content: CreateVisitTitle.HOST_INFO,
          }),
        },
        NEXT: {
          target: CreateVisitStates.VISITOR_DETAILS,
          actions: assign({
            step: '3',
            content: CreateVisitTitle.VISITOR_DETAILS,
          }),
        },
      },
    },
    [CreateVisitStates.VISITOR_DETAILS]: {
      on: {
        BACK: {
          target: CreateVisitStates.DESTINATION_INFO,
          actions: assign({
            step: '2',
            content: CreateVisitTitle.DESTINATION_INFO,
          }),
        },
        NEXT: {
          target: CreateVisitStates.DATES_INFO,
          actions: assign({
            step: '4',
            content: CreateVisitTitle.DATES_INFO,
          }),
        },
      },
    },
    [CreateVisitStates.DATES_INFO]: {
      on: {
        BACK: {
          target: CreateVisitStates.VISITOR_DETAILS,
          actions: assign({
            step: '3',
            content: CreateVisitTitle.VISITOR_DETAILS,
          }),
        },
        NEXT: {
          target: CreateVisitStates.ADDITIONAL_INFORMATION,
          actions: assign({
            step: '5',
            content: CreateVisitTitle.ADDITIONAL_INFORMATION,
          }),
        },
      },
    },
    [CreateVisitStates.ADDITIONAL_INFORMATION]: {
      on: {
        BACK: {
          target: CreateVisitStates.DATES_INFO,
          actions: assign({
            step: '4',
            content: CreateVisitTitle.DATES_INFO,
          }),
        },
        NEXT: {
          target: CreateVisitStates.CONFIRMATION,
          actions: assign({
            step: '6',
            content: CreateVisitTitle.CONFIRMATION,
          }),
        },
      },
    },
    [CreateVisitStates.CONFIRMATION]: {
      on: {
        BACK: {
          target: CreateVisitStates.ADDITIONAL_INFORMATION,
          actions: assign({
            step: '5',
            content: CreateVisitTitle.ADDITIONAL_INFORMATION,
          }),
        },
      },
    },
  },
});
